import { Sparkles } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { errText } from "@/components/pipeline/utils";

export const AgentSynthesis = ({ data, period, filters }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data: res } = await api.post("/agent-stats/synthesis", { period, filters, total: data.total, ranking: data.ranking.slice(0, 40), by_pipeline: data.by_pipeline.slice(0, 30) });
      setText(res.summary);
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <section className="agent-synthesis" data-testid="agent-synthesis">
      <header>
        <span><Sparkles size={15} /> Synthèse IA</span>
        <span className="agent-synthesis-actions">
          <button type="button" className="secondary-button" onClick={run} disabled={busy || !data?.total} data-testid="agent-synthesis-generate">{busy ? "Rédaction…" : text ? "Actualiser" : "Générer la synthèse"}</button>
        </span>
      </header>
      {text ? <p data-testid="agent-synthesis-text">{text}</p> : <p className="agent-synthesis-hint">Un résumé des chiffres affichés (meilleurs agents, écarts, pipelines) avec des actions conseillées.</p>}
    </section>
  );
};
